import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { ArrowRight } from 'lucide-react';

// Contenu éditorial gardé près de la mise en page : ces textes ne servent qu'ici.
const COPY = {
  fr: {
    eyebrow: 'Avantages',
    title: 'Ce que la plateforme change au quotidien',
    lede: "FretManager couvre la chaîne complète d'un envoi international : enregistrement du colis, "
      + 'départ, dédouanement, livraison et facturation. Une seule saisie, un seul dossier, '
      + 'des informations cohérentes du dépôt jusqu\'à la preuve de livraison.',
    cta: 'Demander une démo',
    cards: [
      {
        title: 'Efficacité opérationnelle',
        paragraphs: [
          "Le colis s'enregistre en un parcours guidé : trajet, contacts, contenu, paiement. "
          + 'Plusieurs colis pour un même client se saisissent en une fois, avec leurs photos.',
          'Chaque colis reçoit son code de suivi et son étiquette imprimable. Le client peut '
          + 'saisir lui-même sa déclaration en scannant un QR code ; le partenaire vérifie et valide.',
        ],
      },
      {
        title: 'Maîtrise des coûts',
        paragraphs: [
          'La grille tarifaire par route calcule le montant à partir du poids et de la catégorie '
          + "de marchandise. Le prix d'un envoi se répartit automatiquement entre ses colis.",
          'La facture est générée dès la création du colis, avec les paiements, avances et '
          + 'moyens de règlement associés.',
        ],
      },
      {
        title: 'Visibilité de bout en bout',
        paragraphs: [
          'Chaque changement de statut est horodaté et attribué à son auteur, de la collecte '
          + 'à la remise au destinataire.',
          'Expéditeur et destinataire sont prévenus par WhatsApp et par e-mail aux étapes clés, '
          + 'et suivent le colis avec son code, sans compte à créer.',
        ],
      },
    ],
  },
  en: {
    eyebrow: 'Benefits',
    title: 'What the platform changes day to day',
    lede: 'FretManager covers the full chain of an international shipment: package registration, '
      + 'departure, customs, delivery and invoicing. One entry, one record, consistent data from '
      + 'drop-off to proof of delivery.',
    cta: 'Request a demo',
    cards: [
      {
        title: 'Operational efficiency',
        paragraphs: [
          'A package is registered through a guided flow: route, contacts, contents, payment. '
          + 'Several packages for the same client are entered at once, with their photos.',
          'Each package gets its tracking code and printable label. Clients can fill in their own '
          + 'declaration by scanning a QR code; the partner reviews and validates it.',
        ],
      },
      {
        title: 'Cost control',
        paragraphs: [
          'The route pricing grid derives the amount from weight and merchandise category. '
          + "A shipment's price is split automatically across its packages.",
          'The invoice is generated as soon as the package is created, with its payments, '
          + 'advances and payment methods.',
        ],
      },
      {
        title: 'End-to-end visibility',
        paragraphs: [
          'Every status change is timestamped and attributed to its author, from pickup to '
          + 'hand-over to the recipient.',
          'Sender and recipient are notified by WhatsApp and email at key steps, and track the '
          + 'package with its code, with no account to create.',
        ],
      },
    ],
  },
};

const Benefits = () => {
  const { language } = useLanguage();
  const navigate = useNavigate();
  const copy = COPY[language === 'en' ? 'en' : 'fr'];

  return (
    <section id="benefits" className="landing-section landing-section--alt">
      <div className="landing-diagonal" aria-hidden="true" />
      <div className="landing-section-inner">
        <span className="landing-section-eyebrow">{copy.eyebrow}</span>
        <h2 className="landing-section-title">{copy.title}</h2>
        <p className="landing-lede">{copy.lede}</p>

        <div className="landing-benefit-grid">
          {copy.cards.map((card) => (
            <article key={card.title} className="landing-benefit-card">
              <h3>{card.title}</h3>
              {card.paragraphs.map((p, i) => <p key={i}>{p}</p>)}
            </article>
          ))}
        </div>

        <button className="btn-primary landing-section-cta" onClick={() => navigate('/contact')}>
          {copy.cta}
          <ArrowRight size={16} />
        </button>
      </div>
    </section>
  );
};

export default Benefits;
